/**
 * Aiká — Contagem regressiva da página "Em breve"
 * Atualiza a cada segundo até a data configurada no customizer.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-countdown]').forEach((wrap) => {
    const targetDate = new Date(wrap.dataset.countdownTarget);
    if (Number.isNaN(targetDate.getTime())) return;

    const daysEl = wrap.querySelector('[data-countdown-days]');
    const hoursEl = wrap.querySelector('[data-countdown-hours]');
    const minutesEl = wrap.querySelector('[data-countdown-minutes]');
    const secondsEl = wrap.querySelector('[data-countdown-seconds]');

    const pad = (value) => String(value).padStart(2, '0');

    const update = () => {
      const now = new Date();
      const diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        clearInterval(timer);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    update();
    const timer = setInterval(update, 1000);
  });
});
